import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from '@/components/Card'

interface PaymentMethodsCardProps {
  className?: string
}

const linkOnPayments = 'https://www.aquadental.se/priser/avbetalning'

export const PaymentMethodsCard: FC<PaymentMethodsCardProps> = ({ className }) => {
  const { t } = useTranslation('payment-methods-card')

  return (
    <Card className={className} title={t('title')} type="primary">
      <>
        <p>{t('description')}</p>
        <p>
          {t('link_on_more')}{' '}
          <a href={linkOnPayments} className="break-all underline" target="_blank" rel="noopener noreferrer">
            {linkOnPayments}
          </a>
        </p>
      </>
    </Card>
  )
}

export default PaymentMethodsCard
